'use strict';

exports = module.exports = require('./lib/memoizer')['default'];
exports['default'] = exports;



//////////////////
// WEBPACK FOOTER
// ./node_modules/intl-format-cache/index.js
// module id = 644
// module chunks = 0